import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Banner.css";
import { Col, Container, Row } from "react-bootstrap";
import Typewriter from "typewriter-effect";
import { Button } from "react-bootstrap";
import bannerLeft from "../../../images/Source code-amico.svg";

const Banner = () => {
   AOS.init();
   return (
      <div
         className="d-flex justify-content-center align-items-center bg-dark"
         style={{ paddingTop: "250px" }}
      >
         <Container>
            <Row>
               <Col xs={12} md={7} className="text-white ">
                  <div
                     data-aos="fade-right"
                     data-aos-easing="ease-in-out"
                     data-aos-duration="2000"
                  >
                     <h1
                        className="fw-bold fs-1 mt-5 text-left"
                        style={{ textAlign: "left" }}
                     >
                        {" "}
                        Hi, I'm <br /> Md. Bakhtiar Abid{" "}
                     </h1>{" "}
                     <h4 className="text-info" style={{ textAlign: "left" }}>
                        <Typewriter
                           options={{
                              strings: [
                                 "React Developer",
                                 "MERN Stack Developer",
                                 "JavaScript Developer",
                              ],
                              autoStart: true,
                              loop: true,
                           }}
                        />
                     </h4>
                     <p className="" style={{ textAlign: "justify" }}>
                        A web developer who is self-motivated and passionate. To
                        achieve confidence and popularity by utilizing my
                        opportunities in the future of web development and
                        expressing my original creative talents for the progress
                        of myself and the organization. I'm constantly
                        interested in learning new things and gaining experience
                        with new activities.
                     </p>
                     {/* <div style={{ textAlign: "left" }}>
                        <a
                           className="text-decoration-none fs-5 fw-bold"
                           // href="https://drive.google.com/u/1/uc?id=17GekidaqoFM4cWCpIj_sjd-VzhXeOaky&export=download"
                        >
                           <Button>
                              {" "}
                              <i className="fas fa-file-download me-1"></i>{" "}
                              Resume
                           </Button>
                        </a>
                     </div> */}
                  </div>
               </Col>
               <Col xs={12} md={5}>
                  <div
                     data-aos="fade-left"
                     data-aos-easing="ease-in-out"
                     data-aos-duration="2000"
                  >
                     <img className="img-fluid" src={bannerLeft} alt="" />

                     
                  </div>
               </Col>
            </Row>
         </Container>
      </div>
   );
};

export default Banner;
